export default "__VITE_ASSET__0p0u1KFk__"